module.exports = __webpack_public_path__ + "img/chinesecompany114.fac61029.png";